import { createSlice } from '@reduxjs/toolkit'
import { notesTexts } from 'locale/es'
import noteService from 'services/NotesService'
import { toast } from './notificationReducer'

const initialState = { data: [], loading: false, error: null }

const noteSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    setNotes(state, action) {
      const { data } = action.payload

      return { ...state, data, loading: false, error: null }
    },
    appendNote(state, action) {
      const { data } = action.payload

      return { ...state, data: [...state.data, data], loading: false, error: null }
    },
    updateNote(state, action) {
      const { data } = action.payload

      const updatedNotes = state.data.map((note) =>
        note.id !== data.id ? note : data
      )

      return { ...state, data: updatedNotes, loading: false, error: null }
    },
    deleteNote(state, action) {
      const newDataState = state.data.filter((note) => note.id !== action.payload)

      return { ...state, data: newDataState, loading: false, error: null }
    },
    setNotesLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setNotesError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetNotesState(state, action) {
      return initialState
    }
  },
})

export const { setNotes, appendNote, updateNote, deleteNote, setNotesLoading, setNotesError, resetNotesState } =
  noteSlice.actions

export const initializePatientNotes = (patientId) => {
  return async (dispatch) => {
    try {
      dispatch(setNotesLoading());

      const { data } = await noteService.getAll(patientId)
      dispatch(setNotes({ data }))
    }
    catch (error) {
      console.error(error)
      dispatch(setNotesError({ message: error.message, status: error.response?.status }));
      dispatch(toast(notesTexts.LOADING_ERROR, 'error'))
    }
  }
}

export const createNote = (noteObj) => {
  return async (dispatch) => {
    try {
      const { data } = await noteService.create(noteObj)
      dispatch(appendNote({ data }))
      dispatch(toast(notesTexts.CREATED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setNotesError({ message: error.message, status: error.response?.status }));
      throw error
    }
  }
}

export const updateNoteAction = (fieldsToUpdate) => {
  return async (dispatch) => {
    try {
      const { data } = await noteService.update(fieldsToUpdate.id, fieldsToUpdate)
      dispatch(updateNote({ data }))
      dispatch(toast(notesTexts.EDITED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setNotesError({ message: error.message, status: error.response?.status }));
      throw error
    }
  }
}

export const deleteNoteAction = (id) => {
  return async (dispatch) => {
    try {
      await noteService.remove(id)
      dispatch(deleteNote(id))
      dispatch(toast(notesTexts.DELETED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setNotesError({ message: error.message, status: error.response?.status }));
      dispatch(toast(notesTexts.DELETED_ERROR, 'error'))
    }
  }
}

export default noteSlice.reducer